import { EMPTY_OBJECT } from '../../../constants/common'
import { FormButtonAdd } from '../FormButtonAdd'
import { FormButtonCancel } from '../FormButtonCancel'
import { FormButtonClear } from '../FormButtonClear'
import { FormButtonSubmit } from '../FormButtonSubmit'
import { FormUploadAction } from '../FormUploadAction'

import * as styles from './FormActions.module.css'

/*
 submitProps may contains props `isLoading, title`
 cancelProps, clearProps may contains props `title, tooltipTitle, onClick`
 uploadProps may contains `onFinishUpload (req), onStartUpload (req), onUploadErrors (req), title`
 */
function FormActions({
  ButtonAdd = FormButtonAdd,
  ButtonCancel = FormButtonCancel,
  ButtonClear = FormButtonClear,
  ButtonSubmit = FormButtonSubmit,
  Container = 'div',
  More,
  UploadComponent = FormUploadAction,
  addProps: { disabled: isAddDisabled, ...addProps } = EMPTY_OBJECT,
  cancelProps,
  children,
  className = styles.FormActions,
  clearProps,
  containerProps,
  isSubmitting,
  moreProps,
  submitProps: { disabled: isSubmitDisabled, ...submitProps } = EMPTY_OBJECT,
  uploadProps: { disabled: isUploadDisabled, ...uploadProps } = EMPTY_OBJECT,
}) {
  return (
    <Container {...containerProps} className={className}>
      {ButtonSubmit ? (
        <ButtonSubmit
          {...submitProps}
          disabled={isSubmitting || isSubmitDisabled}
        />
      ) : null}
      {ButtonCancel ? <ButtonCancel {...cancelProps} /> : null}
      {ButtonClear ? <ButtonClear {...clearProps} /> : null}
      {ButtonAdd ? (
        <ButtonAdd {...addProps} disabled={isSubmitting || isAddDisabled} />
      ) : null}
      {UploadComponent ? (
        <UploadComponent
          {...uploadProps}
          disabled={isSubmitting || isUploadDisabled}
        />
      ) : null}
      {More ? <More {...moreProps} disabled={isSubmitting} /> : null}
      {children}
    </Container>
  )
}

export default FormActions
